export default "__VITE_ASSET__DdewQ561__"